module.exports = __webpack_public_path__ + "static/img/wheel.a7903d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wheel.png
// module id = cYKD
// module chunks = 1